import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import DualListBox from "../../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import CommonSelect from "../../../../../core/common/commonSelect";
import Select from 'react-select'
import { Toast } from "react-bootstrap";

type Permission = { id: number; name: string };

interface User {
    id: number;
    name: string;
  }

  interface GroupType {
    agent_group_type_id: number;
    agent_group_type_name: string;
  }

type Admin = {
  permissions: Array<number>;
  name: string | null;

  id: number;
};

interface Option {
    value: number;
    label: string;
  }

  interface ErrorMessages {
    team_name?: string[];
  }
  

const AddMetaOnBoardingTeamManagement = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [users, setUsers] = useState<User[]>([]);
  const [usersDropdown, setUsersDropdown] = useState<Permission[]>([]);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [selectedOption1, setSelectedOption1] = useState<Option | null>(null);
  const [teamName, setTeamName] = useState<string>("");
  const [grouptypes, setGroupTypes] = useState<GroupType[]>([]);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
const [toastMessage, setToastMessage] = useState("");
useEffect(() => {
    if((showSolidDangerToast || showSolidSuccessToast) === true){
    setTimeout(() => setShowSolidDangerToast(false), 5000);
    setTimeout(() => setshowSolidSuccessToast(false), 5000);
    }
  },[toastMessage])
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const options1: Option[] = users.map(user => ({
    value: user.id,
    label: user.name,
  }));

  const options2: Option[] = grouptypes.map(user => ({
    value: user.agent_group_type_id,
    label: user.agent_group_type_name,
  }));


  const handleChange = (option: Option | null) => {
    setSelectedOption(option);
    if (option) {
      console.log('Selected ID:', option.value);
    }
  };

  const handleChange1 = (option: Option | null) => {
    setSelectedOption1(option);
    if (option) {
      console.log('Selected ID:', option.value);
    }
  };


  const handlePermissionsChange = (selected: Permission[]) => {
    setChosenPermissions(selected);
  };
  const [newAdmin, setNewAdmin] = useState<Admin>({
    name: null,
    id: 0,
    permissions: [],
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchTeamLead = async () => {
    const resposne = await fetch(`${webApi}/meta_onboard/users_dropdown_for_meta_onboard_team_lead/`, options);
    return await resposne.json();
  };

  const fetchUserData = async () => {
    const resposne = await fetch(`${webApi}/meta_onboard/users_dropdown_for_meta_onboard_team_members/`, options);
    return await resposne.json();
  };


  const fetchData = async () => {
    setIsLoading(true); // Start loading
    try {
      const [permissionsData,userData] = await Promise.all([fetchTeamLead(), fetchUserData()]);

      // Convert the fetched data to the Permission type
      const formattedPermissions = permissionsData.map(
        (permission: { id: number; name: string }): Permission => ({
          id: permission.id,
          name: permission.name,
        })
      );
      const formattedUsers = userData.map(
        (user: { id: number; name: string }): User => ({
          id: user.id,
          name: user.name,
        })
      );

      setPermissions(formattedPermissions);
      setUsers(permissionsData);
      setUsersDropdown(formattedUsers);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if (!checkPermission("add_metaonboardmgmt", "metaonboardmgmt")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData();
    }
  }, [userPermissions]);

  const updateData = async () => {
    const newTeam = {
        name: teamName,
        team_lead: selectedOption ? selectedOption.value : null,
        team_members: chosenPermissions.map(permission => permission.id),
      };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newTeam),
    };
    const url = `${webApi}/meta_onboard/meta_onboard_mgmt/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();
      setErrorMessage(errorData);
      setToastMessage(errorData.team_name);
      if (toastMessage !== "") {
        setShowSolidDangerToast(true);
      }
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await updateData();
      navigate(routes.metaOnboardingTeamManagement);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTeamName(e.target.value);
  };

  useEffect(() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Add Team</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.metaOnboardingTeamManagement}>
                      Team Management List
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Add Team</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add Group */}
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div
                      className="form-group mb-3"
                      style={{
                        width: "70%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "28%"  }}>
                        <label className="form-label">Team Name</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errorMessage.team_name ? "is-invalid" : ""
                          }`}
                          name="teamName"
                          placeholder="Team Name"
                          onChange={handleInputChange}
                          value={teamName}
                          required
                        />
                         {errorMessage.team_name && (
                        <div className="invalid-feedback">
                          {errorMessage.team_name[0]}
                        </div>
                      )}
                      </div>
                      <div style={{ width: "28%" }}>
                        <label className="form-label">Team Leader</label>
                        <Select
                          value={selectedOption}
                          onChange={handleChange}
                          options={options1}
                          placeholder="Select a team leader"
                          required 
                        />
                      </div>
                    </div>

                    <div className="form-group dual-list-box-container">
                      <label className="form-label">Select Team Members</label>
                      <DualListBox
                        options={usersDropdown}
                        selected={chosenPermissions}
                        onChange={handlePermissionsChange}
                      />
                    </div>
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.metaOnboardingTeamManagement}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      </div>
    </div>
  );
};

export default AddMetaOnBoardingTeamManagement;
